import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Facets from "./Facets";

export default function FacetsContainer({ containerObject, templateName, contentId, dataZone }) {
	const [facetObj, setfacetObj] = useState(containerObject)

	return (
		<>
			<div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0 ose-facet-container`} >
				{containerObject && containerObject.hideResultsPageFlag && containerObject.hideResultsPageFlag == true ? "" : <>
				<div className="d-none d-lg-block mx-2 mt-2 ose-facet">
					<h2 className="os-sidepanel-heading" >{facetObj.currentProductCategoryName ? facetObj.currentProductCategoryName : facetObj.zeroResultsFlag ? "" : facetObj && facetObj.facets && facetObj.facets.length > 0 ? "Refine Results" : ""}</h2>
					<div className="os-side-list">
						<ul className="list-group facet-padding">
							{facetObj && facetObj.facets && facetObj.facets.length > 0 ? facetObj.facets.map((facet, idx) => {
							var categoryFacet = facet && (facet.Content_Category || facet.Product_Category) ? (facet.Content_Category || facet.Product_Category) : ""
								return (<>
									{containerObject && containerObject.isChildCategoryAvailable && categoryFacet ? categoryFacet.map((item, index) => {
										return (<li className="list-group-item">
											{item.childCategory != null && item.childCategory.length > 0 ?
												<>
													<div className="accordion childFacets" id={`accordionExample${index}`} >
														<div className="accordion-item" >
															<h2 className="accordion-header" id="headingOne">
																<button className="ose-accordion accordion-button list-group-item-action accordion-button-header collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${index}`} aria-expanded="true" aria-controls="collapseOne">
																	{item.name}
																</button>
															</h2>
														</div>
														<div id={`collapseOne${index}`} className="accordion-collapse collapse accordion-body-width" aria-labelledby="headingOne">
															{item.childCategory.map((oneCategory, index) => {
																return (<>
																	<Link className="accordion-body-padding row" to={oneCategory.childCategoryUrl}>{oneCategory.childCategoryName}</Link>
																</>)
															})}
														</div>
													</div>
												</>
												:
												<Link className="list-group-item-action" to={item.url}>{item.name}<span className="c-list-icon">
													<i className="fa fa-play fa-icon-style" aria-hidden="true"></i>
												</span>
												</Link>
											}
										</li>)
									})
										: <>
											<Facets
												noOfFacetsOpen={containerObject && containerObject.attributes && containerObject.attributes.noOfDimensionShowMore ? containerObject.attributes.noOfDimensionShowMore : 5 }
												value={facet}
												index={idx}
												facetsAttributes={containerObject && containerObject.facetsAttributeValueMap ? containerObject.facetsAttributeValueMap : ""}
											/>
										</>}
								</>)
							}) : ""}
						</ul>
					</div>
				</div>

				{/* Mobile view  */}
				<div className={`d-lg-none d-block ose-facet ${containerObject && containerObject.isChildCategoryAvailable ? "d-none" : "" }`}>
					{/* <button class="btn btn-primary facet-refine-btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Refine</button> */}
					<div class="offcanvas_facet offcanvas offcanvas-end os-side-list" tabindex="-1" id="oseOffcanvasRight" aria-labelledby="oseOffcanvasRight">
						<div class="offcanvas-header offcanvas_facet_header">
							<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" style={{marginLeft:"22rem",marginTop:"0rem"}}></button>
						</div>
						<div class="offcanvas-body">
							{containerObject && containerObject.selectedCrumb && containerObject.selectedCrumb.length > 0 ? <>
								<h3 class="os-sidepanel-heading">Selected Options</h3>
								<div class="os-side-list ose-selctedcrumb">
									<ul class="list-group">
										{containerObject.selectedCrumb ? containerObject.selectedCrumb.map((selectedCrumb) => {
											return (
												<li class="list-group-item selectedCrumb">
													<Link to={selectedCrumb.navigationState ? selectedCrumb.navigationState : ""} ><span class="list-selected-item">
														<strong>{selectedCrumb.displayName ? selectedCrumb.displayName : ""}:&nbsp;</strong> {selectedCrumb.label ? selectedCrumb.label : ""}&nbsp;&nbsp;</span>
														<span class="c-list-icon c-selected-icon">
															<i class="bi bi-x"></i>
														</span>
													</Link>
												</li>
											)
										})
											: ""}
									</ul>
								</div>
							</> : ""}


							<h2 className="os-sidepanel-heading" >{facetObj.currentProductCategoryName ? facetObj.currentProductCategoryName : facetObj.zeroResultsFlag ? "" : facetObj && facetObj.facets && facetObj.facets.length > 0 ? "Refine Results" : ""}</h2>
							{facetObj && facetObj.facets && facetObj.facets.length > 0 ? facetObj.facets.map((oneFacet, index) => {
								return (
									<Facets
										noOfFacetsOpen={containerObject && containerObject.attributes && containerObject.attributes.noOfDimensionShowMore ? containerObject.attributes.noOfDimensionShowMore : 5 }
										value={oneFacet}
										index={index}
										facetsAttributes={containerObject && containerObject.facetsAttributeValueMap ? containerObject.facetsAttributeValueMap : ""}
										isMobileView={true}
									/>)
							}) : ""}

						</div>
					</div>
				</div></>}
			</div>
		</>
	);
}
